// English strings for BirthChartChatCard, mounted under `birthChart.card` in
// i18n/locales/en/translation.js.
const card = {
    title: 'Your birth chart',
    view: 'View Chart',
    thumbnailLabel: 'Birth chart wheel',
    sun: 'Sun in {{sign}}',
    moon: 'Moon in {{sign}}',
    rising: '{{sign}} rising'
};

export default card;
